import { request } from "@api/service";
import { api3 } from "@api/env";
export function getReceiversList(params) {
  return request({
    baseURL: api3,
    url: "/api/receivers",
    method: 'get',
    getHeaders: true,
    withCredentials: false,
    params: params
  });
}
export function getReceiver(receiverId) {
  return request({
    baseURL: api3,
    url: "/api/receivers/".concat(receiverId),
    method: 'get',
    getHeaders: true,
    withCredentials: false
  });
}
export function updateReceiver(receiverId, data) {
  var customHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return request({
    baseURL: api3,
    url: "/api/receivers/".concat(receiverId),
    method: 'put',
    data: data,
    output: true,
    withCredentials: false,
    customHeaders: customHeaders
  });
}
export function removeReceiver(receiverId) {
  return request({
    baseURL: api3,
    url: "/api/receivers/".concat(receiverId),
    method: 'delete',
    output: true,
    withCredentials: false
  });
}
export function createReceiverByAdmin(data) {
  return request({
    baseURL: api3,
    url: "/api/receivers",
    method: 'post',
    data: data,
    output: true,
    withCredentials: false
  });
}
export function createReceiver(data, taskId) {
  return request({
    baseURL: api3,
    url: "/api/receivers/tasks/".concat(taskId),
    method: 'post',
    data: data,
    output: true,
    withCredentials: false
  });
}